import ShopThisPostCarousel from 'components/Community/ShopThisPostCarousel/ShopThisPostCarousel';
import { withShopThisPostCarouselProps } from 'viewModel/gallery/withShopThisPostCarouselProps';

const ConnectedShopThisPostCarousel = withShopThisPostCarouselProps(ShopThisPostCarousel);

export default ConnectedShopThisPostCarousel;
